import { Field, Label } from '../Field';
import ImageUploader from '../ImageUploader';
import MultiImageUploader from '../MultiImageUploader';

function ImagesTab({ logo, featuredImage, coverImages, t }) {
    return (
        <div className="space-y-2">
            <Field>
                <Label>{t('logo')}</Label>
                <ImageUploader name="logo" current={logo} />
            </Field>

            <Field>
                <Label>{t('featured-image')}</Label>
                <ImageUploader name="featured_image" current={featuredImage} />
            </Field>

            <Field>
                <Label>{t('cover-images')}</Label>
                <MultiImageUploader name="cover_images" current={coverImages} multiple />
            </Field>
        </div>
    );
}

export default ImagesTab;
